import {
    PENDING_IMPLANT_LIST_REQUEST,
    PENDING_IMPLANT_LIST_SUCCESS,
    PENDING_IMPLANT_LIST_FAIL,

    PENDING_IMPLANT_DETAILS_REQUEST,
    PENDING_IMPLANT_DETAILS_SUCCESS,
    PENDING_IMPLANT_DETAILS_FAIL,

    PENDING_IMPLANT_DELETE_REQUEST,
    PENDING_IMPLANT_DELETE_SUCCESS,
    PENDING_IMPLANT_DELETE_FAIL,

    PENDING_IMPLANT_CREATE_REQUEST,
    PENDING_IMPLANT_CREATE_SUCCESS,
    PENDING_IMPLANT_CREATE_FAIL,
    PENDING_IMPLANT_CREATE_RESET,

    PENDING_IMPLANT_UPDATE_REQUEST,
    PENDING_IMPLANT_UPDATE_SUCCESS,
    PENDING_IMPLANT_UPDATE_FAIL,

    PENDING_IMPLANT_APPROVE_REQUEST,
    PENDING_IMPLANT_APPROVE_SUCCESS,
    PENDING_IMPLANT_APPROVE_FAIL,

    PENDING_IMPLANT_REJECT_REQUEST,
    PENDING_IMPLANT_REJECT_SUCCESS,
    PENDING_IMPLANT_REJECT_FAIL,
} from "../constants/pendingImplantConstants";

export const pendingImplantListReducer = (
    state = {
        pendingImplants: []
    }, action) => {
    switch (action.type) {
        case PENDING_IMPLANT_LIST_REQUEST:
            return { loading: true, pendingImplants: [] };
        case PENDING_IMPLANT_LIST_SUCCESS:
            return {
                loading: false,
                pendingImplants: action.payload.pendingImplants,
                totalPages: action.payload.totalPages,
                currentPage: action.payload.currentPage,
                totalCount: action.payload.totalCount,
            };
        case PENDING_IMPLANT_LIST_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
}

export const pendingImplantDetailsReducer = (
    state = {
        pendingImplant: {}
    }, action) => {
    switch (action.type) {
        case PENDING_IMPLANT_DETAILS_REQUEST:
            return { loading: true, ...state };
        case PENDING_IMPLANT_DETAILS_SUCCESS:
            return { loading: false, pendingImplant: action.payload };
        case PENDING_IMPLANT_DETAILS_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
}

export const pendingImplantDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case PENDING_IMPLANT_DELETE_REQUEST:
            return { loading: true }

        case PENDING_IMPLANT_DELETE_SUCCESS:
            return { loading: false, success: true }

        case PENDING_IMPLANT_DELETE_FAIL:
            return { loading: false, error: action.payload }

        default:
            return state
    }
}

export const pendingImplantCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case PENDING_IMPLANT_CREATE_REQUEST:
            return { loading: true }

        case PENDING_IMPLANT_CREATE_SUCCESS:
            return { loading: false, success: true, pendingImplant: action.payload }

        case PENDING_IMPLANT_CREATE_FAIL:
            return { loading: false, error: action.payload }

        case PENDING_IMPLANT_CREATE_RESET:
            return {}

        default:
            return state
    }
}

export const pendingImplantUpdateReducer = (state = { pendingImplant: {} }, action) => {
    switch (action.type) {
        case PENDING_IMPLANT_UPDATE_REQUEST:
            return { loading: true }

        case PENDING_IMPLANT_UPDATE_SUCCESS:
            return { loading: false, success: true, pendingImplant: action.payload }

        case PENDING_IMPLANT_UPDATE_FAIL:
            return { loading: false, error: action.payload }

        default:
            return state
    }
}

export const pendingImplantApproveReducer = (state = {}, action) => {
    switch (action.type) {
        case PENDING_IMPLANT_APPROVE_REQUEST:
            return { loading: true }

        case PENDING_IMPLANT_APPROVE_SUCCESS:
            return { loading: false, success: true, data: action.payload }

        case PENDING_IMPLANT_APPROVE_FAIL:
            return { loading: false, error: action.payload }

        default:
            return state
    }
}

export const pendingImplantRejectReducer = (state = {}, action) => {
    switch (action.type) {
        case PENDING_IMPLANT_REJECT_REQUEST:
            return { loading: true }

        case PENDING_IMPLANT_REJECT_SUCCESS:
            return { loading: false, success: true, data: action.payload }

        case PENDING_IMPLANT_REJECT_FAIL:
            return { loading: false, error: action.payload }

        default:
            return state
    }
}





